import { integer, pgTable, text } from 'drizzle-orm/pg-core';
import { timestamps } from './utils/index.js';
import { userActions } from './utils/user-actions.js';
import { uuidv7 } from './utils/uuidv7.js';
export const addresses = pgTable('address', {
    id: uuidv7('id').primaryKey(),
    cyproOldId: integer('cypro_old_id'),
    country: text('country'),
    region: text('region'),
    city: text('city'),
    postalCode: text('postal_code'),
    addressLine: text('address_line'),
    additionalInfo: text('additional_info'),
    ...timestamps(),
    ...userActions(),
});
//# sourceMappingURL=addresses.js.map